<template>
    <swiper-pagination v-bind="$attrs" class="swiper-pagination--around-outlined"><slot /></swiper-pagination>
</template>

<script>
import SwiperPagination from "@/components/publish/styles/swipers/swiper-pagination.vue";

export default {
    props: {},
    components: { SwiperPagination },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.swiper-pagination--around-outlined {
    ::v-deep {
        .swiper-pagination {
            &-bullet {
                position: relative;
                width: 6px;
                height: 6px;
                background-color: transparent;
                border: 0;
                opacity: 1;
                margin: 0 6px;
                &::before,
                &::after {
                    content: "";
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    -webkit-transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                    display: block;
                    border-radius: 100%;
                }
                &::before {
                    z-index: 1;
                    width: 100%;
                    height: 100%;
                    opacity: 0.2;
                    background-color: currentColor;
                }
                &::after {
                    z-index: -1;
                    width: 18px;
                    height: 18px;
                    opacity: 0;
                    background-color: transparent;
                    border: 1px solid currentColor;
                }
                &-active {
                    margin: 0 10px;
                    &::before {
                        opacity: 1;
                    }
                    &::after {
                        opacity: 1;
                    }
                }
            }
        }
    }

    &.swiper-pagination {
        &--sm {
            ::v-deep {
                .swiper-pagination {
                    &-bullet {
                        width: 4px;
                        height: 4px;
                        margin: 0 4px;
                        &::after {
                            width: 14px;
                            height: 14px;
                        }
                        &-active {
                            margin: 0 8px;
                        }
                    }
                }
            }
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .swiper-pagination--around-outlined {
        ::v-deep {
            .swiper-pagination {
                &-bullet {
                    width: 8px;
                    height: 8px;
                    &::after {
                        width: 20px;
                        height: 20px;
                    }
                    &-active {
                        margin: 0 12px;
                    }
                }
            }
        }

        &.swiper-pagination {
            &--sm {
                ::v-deep {
                    .swiper-pagination {
                        &-bullet {
                            width: 6px;
                            height: 6px;
                            &::after {
                                width: 16px;
                                height: 16px;
                            }
                            &-active {
                                margin: 0 10px;
                            }
                        }
                    }
                }
            }
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
